import React, { useEffect, useRef, useState } from "react";
import "./Navbar.css";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate } from "react-router-dom";
import { isUserAuthenticated } from "../../routing/AuthUtils";
import ProfileDrop from "./ProfileDrop";
import { servicePost } from "../../helper/api";
import { useSelector } from "react-redux";
import NotificationDrawer from "../../Dashboard/CreateOrder/drawers/NotificationDrawer";
import MobileProfileDrawer from "../../Dashboard/Drawers/MobileProfileDrawer";
import MenuDrawer from "../../Dashboard/Drawers/MenuDrawer";

const Navbar = () => {
  const [userData, setUserData] = useState([]);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [showProfileDrop, setShowProfileDrop] = useState(false);
  const [showNotificationDrawer, setShowNotificationDrawer] = useState(false);
  const [showMenuDrawer, setShowMenuDrawer] = useState(false);
  const [notificationCount, setNotificationCount] = useState();
  // const [isUserAuthenticate, setIsUserAuthenticate] = useState(false);
  const [showChatDrawer, setShowChatDrawer] = useState(false);
  const handleCloseChat = () => setShowChatDrawer(false);

  // get loggedInUser for Redux
  const [logedInUser, setLogedInUser] = useState(
    JSON.parse(localStorage.getItem("wealth_user"))?.data
  );

  const notificationDep = useSelector(
    (state) => state.notificationDep.notificationDep
  );

  console.log("notificationDep", notificationDep);
  console.log("logedInUser", logedInUser);

  // get AuthToken from localStorage
  const authToken = localStorage.getItem("token");
  const notification = "";

  const profileDropdownRef = useRef(null);
  const showProfileDropdown = () => {
    setShowProfileDrop(true);
  };

  const hideProfileDropdown = () => {
    setShowProfileDrop(false);
  };

  const handleShowChat = (title) => {
    setShowChatDrawer(true);
  };

  const deleteNotificationCount = async () => {
    try {
      const deleteCountRes = await servicePost(
        "admin2fa/updateNotification",
        {
          // id: logedInUser?.id,
        },
        notification,
        authToken
      );
      console.log("deleteCountRes", deleteCountRes);

      if (deleteCountRes.message == "SUCCESS") {
        setNotificationCount(0);
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const handleCloseNotification = () => setShowNotificationDrawer(false);
  const handleShowNotification = (title) => {
    setShowNotificationDrawer(true);
    deleteNotificationCount();
  };

  const handleCloseMenuDrawer = () => setShowMenuDrawer(false);
  const handleShowMenuDrawer = (title) => {
    setShowMenuDrawer(true);
  };

  // Get Notification Count
  const getNotificationCount = async () => {
    try {
      const notificationCountRes = await servicePost(
        `admin2fa/latestNotificationCount`,
        {
          // accountId: logedInUser?.id,
        },
        notification,
        authToken
      );
      console.log("notificationCountRes", notificationCountRes);
      setNotificationCount(notificationCountRes.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getNotificationCount();
  }, [logedInUser?.id, notificationCount, notificationDep]);

  const location = useLocation();
  const currentpath = location.pathname;

  const navigate = useNavigate();
  const goToProfilePage = () => {
    navigate("/");
    //  navigate("/profile");
    // navigate("/login");
  };

  const goToDashboard = () => {
    navigate("/");
  };

  // Hide Profile Dropdown when Click Outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        profileDropdownRef.current &&
        !profileDropdownRef.current.contains(event.target)
      ) {
        // Clicked outside the dropdown, hide it
        hideProfileDropdown();
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [hideProfileDropdown]);

  return (
    <>
      <Offcanvas
        className="notification-offcanvas-wrapper"
        show={showNotificationDrawer}
        onHide={handleCloseNotification}
        placement="end"
      >
        <Offcanvas.Body>
          <NotificationDrawer onHide={handleCloseNotification} title="Cart" />
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        className="notification-offcanvas-wrapper"
        show={showMenuDrawer}
        onHide={handleCloseMenuDrawer}
        placement="start"
      >
        <Offcanvas.Body>
          <MenuDrawer onHide={handleCloseMenuDrawer} title="Cart" />
        </Offcanvas.Body>
      </Offcanvas>
      <div
        className={
          isUserAuthenticated()
            ? "navbar-main-wrapper dashbord-navbar-active"
            : "navbar-main-wrapper"
        }
      >
        <div className="navbar-main-wrap container">
          <div className="navbar-left-wrap">
            {isUserAuthenticated() && !isMobile ? (
              <div className="navbar-logo-wrap-active">
                <img
                  onClick={goToDashboard}
                  src="./images/icons/yfos-logo.png"
                  alt="logo"
                />
              </div>
            ) : isUserAuthenticated() && isMobile ? (
              <div className="nav-burger-menu">
                <img
                  onClick={handleShowMenuDrawer}
                  src="./images/icons/burger-menu.svg"
                  alt="icon"
                />
              </div>
            ) : (
              <div className="navbar-logo-wrap">
                <img src="./images/icons/logo-white.png" alt="logo" />
              </div>
            )}
          </div>
          {isMobile && isUserAuthenticated() ? (
            <div className="navbar-right-wrap">
              <div className="nav-notification-icon-wrap">
                <svg
                  onClick={handleShowNotification}
                  xmlns="http://www.w3.org/2000/svg"
                  width="35"
                  height="35"
                  viewBox="0 0 35 35"
                >
                  <defs>
                    <clipPath id="clip-path">
                      <rect
                        id="Rectangle_25"
                        data-name="Rectangle 25"
                        width="35"
                        height="35"
                        transform="translate(1460 13)"
                        fill="#fff"
                        opacity="0"
                      />
                    </clipPath>
                  </defs>
                  <g
                    id="Share_Icon"
                    data-name="Share Icon"
                    transform="translate(-1460 -13)"
                    clipPath="url(#clip-path)"
                  >
                    <g id="bell" transform="translate(1466.444 19.384)">
                      <path
                        id="Path_13"
                        data-name="Path 13"
                        d="M7.424,21A4.622,4.622,0,0,0,15.9,21Z"
                        transform="translate(-0.467 -1.547)"
                        fill="#1a1919"
                      />
                      <path
                        id="Path_14"
                        data-name="Path 14"
                        d="M20.823,11.624l-1.608-5.3A8.634,8.634,0,0,0,2.47,6.744L1.222,11.873a4.632,4.632,0,0,0,4.5,5.728H16.39a4.632,4.632,0,0,0,4.433-5.976Z"
                        transform="translate(0 0)"
                        fill="#1a1919"
                      />
                    </g>
                  </g>
                </svg>

                {notificationCount > 0 && (
                  <div className="notification-count-wrap"></div>
                )}
              </div>
            </div>
          ) : !isMobile && isUserAuthenticated() ? (
            <div className="navbar-right-wrap">
              <div className="nav-notification-icon-wrap">
                <svg
                  onClick={handleShowNotification}
                  xmlns="http://www.w3.org/2000/svg"
                  width="35"
                  height="35"
                  viewBox="0 0 35 35"
                >
                  <defs>
                    <clipPath id="clip-path">
                      <rect
                        id="Rectangle_25"
                        data-name="Rectangle 25"
                        width="35"
                        height="35"
                        transform="translate(1460 13)"
                        fill="#fff"
                        opacity="0"
                      />
                    </clipPath>
                  </defs>
                  <g
                    id="Share_Icon"
                    data-name="Share Icon"
                    transform="translate(-1460 -13)"
                    clipPath="url(#clip-path)"
                  >
                    <g id="bell" transform="translate(1466.444 19.384)">
                      <path
                        id="Path_13"
                        data-name="Path 13"
                        d="M7.424,21A4.622,4.622,0,0,0,15.9,21Z"
                        transform="translate(-0.467 -1.547)"
                        fill="#1a1919"
                      />
                      <path
                        id="Path_14"
                        data-name="Path 14"
                        d="M20.823,11.624l-1.608-5.3A8.634,8.634,0,0,0,2.47,6.744L1.222,11.873a4.632,4.632,0,0,0,4.5,5.728H16.39a4.632,4.632,0,0,0,4.433-5.976Z"
                        transform="translate(0 0)"
                        fill="#1a1919"
                      />
                    </g>
                  </g>
                </svg>

                {notificationCount > 0 && (
                  <div className="notification-count-wrap"></div>
                )}
              </div>
              <div className="profile-drop-wrapper">
                {/* <img
                  onClick={goToProfilePage}
                  className="nav-user-icon"
                  src="./assets/icons/user-icon.svg"
                  alt="icon"
                /> */}

                {!userData?.profileImageURL ? (
                  <svg
                    onClick={goToProfilePage}
                    xmlns="http://www.w3.org/2000/svg"
                    width="42"
                    height="42"
                    viewBox="0 0 42 42"
                  >
                    <g
                      id="User_Icon"
                      data-name="User Icon"
                      transform="translate(-1676 -13)"
                    >
                      <g
                        id="Ellipse_6"
                        data-name="Ellipse 6"
                        transform="translate(1676 13)"
                        fill="#fff"
                        stroke="#f3f3f3"
                        strokeWidth="2"
                      >
                        <circle cx="21" cy="21" r="21" stroke="none" />
                        <circle cx="21" cy="21" r="20" fill="none" />
                      </g>
                      <g id="user" transform="translate(1606.23 25.833)">
                        <path
                          id="Path_2"
                          data-name="Path 2"
                          d="M90.4,298.675a5.574,5.574,0,0,0-5.072,5.625v.148a1.021,1.021,0,0,0,1.021,1.021h0a1.021,1.021,0,0,0,1.021-1.021v-.189a3.507,3.507,0,0,1,3.063-3.539,3.407,3.407,0,0,1,3.727,3.054q.016.166.017.333v.34a1.021,1.021,0,0,0,1.021,1.021h0a1.021,1.021,0,0,0,1.021-1.021v-.34a5.451,5.451,0,0,0-5.457-5.445Q90.578,298.663,90.4,298.675Z"
                          transform="translate(0 -289.135)"
                          fill="#1a1919"
                        />
                        <path
                          id="Path_3"
                          data-name="Path 3"
                          d="M132.091,8.167a4.083,4.083,0,1,0-4.083-4.083A4.083,4.083,0,0,0,132.091,8.167Zm0-6.125a2.042,2.042,0,1,1-2.042,2.042A2.042,2.042,0,0,1,132.091,2.042Z"
                          transform="translate(-41.321)"
                          fill="#1a1919"
                        />
                      </g>
                    </g>
                  </svg>
                ) : (
                  <img
                    onClick={goToProfilePage}
                    className="nav-profile-img"
                    src={userData?.profileImageURL}
                    alt="img"
                  />
                )}

                <div
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  className="dropdown profiledrop-arrow-wrap"
                >
                  {/* <img
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    className="profile-drop-icon"
                    src="../images/icons/dropdown-arrow.svg"
                    alt="icon"
                  /> */}

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11.374"
                    height="5.827"
                    viewBox="0 0 11.374 5.827"
                  >
                    <path
                      id="angle-small-down"
                      d="M16.137,8.154a.812.812,0,0,0-1.153,0l-3.72,3.72a.812.812,0,0,1-1.153,0l-3.72-3.72A.813.813,0,1,0,5.235,9.3l3.729,3.729a2.437,2.437,0,0,0,3.444,0L16.137,9.3A.812.812,0,0,0,16.137,8.154Z"
                      transform="translate(-4.999 -7.914)"
                      fill="#1a1919"
                    />
                  </svg>
                  <ul className="dropdown-menu">
                    <ProfileDrop hideProfileDropdown={hideProfileDropdown} />
                  </ul>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default Navbar;
